import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }   from '../../app-lite/api/api.service';
import { VehicleModel } from '../../app-lite/vehicles/models/vehicle';

@Injectable({
  providedIn: 'root'
})
export class CheckaService {
  constructor (
    private apiService      : ApiService,
    private translateService: TranslateService
  ) {}

  search ( vehicle : VehicleModel ) : Promise<VehicleModel> {
    if (!vehicle.plate_number && !vehicle.vin) {
      return Promise.reject(this.translateService.instant('JS_SPACE.CHECKA.PROVIDE_REGO_OR_VIN_NUMBER'));
    }

    return this.apiService.post('/vehicles/find_on_checka', vehicle)
    .then(( vehicle : VehicleModel ) => {
      switch (vehicle.fuel_type) {
        case 'Electric':
          vehicle.fuel_type = 'Electric';
          break;
        case 'Plugin Petrol Hybrid':
        case 'Petrol Hybrid':
          vehicle.fuel_type = 'Petrol/Electro';
          break;
      }

      return vehicle;
    });
  }
}